<script>
  import { colors } from './utils.js';

  export let bgimage = null;
  export let bgfixed = false;
  export let theme = null;

  let style = '';

  if (bgimage) {
    style += `background-image: url(${bgimage});`;
  } else {
    style += 'background-image: none;';
  }

  if (bgfixed) {
    style += ' background-attachment: fixed;';
  }

  if (theme) {
    style += ` color: ${colors[theme]['text']}; background-color: ${colors[theme]['background']};`
  }
</script>

<header style="{style}">
	<div class="col-wide height-full middle">
		<div class="center">
			<slot></slot>
    </div>
	</div>
</header>